import { t } from 'ttag'
import styled from 'styled-components'

import { Heading } from '@h2/components/typography/heading'

import { Link } from '../../../../../../common/components/link'

const StyledHeading = styled(Heading)`
  overflow-wrap: break-word;
`
const PlanName = ({ name }) => {
  if (!name) {
    return (
      <StyledHeading level="5" removeMargins={true}>
        {t`Create a plan to start working towards your goals`}
      </StyledHeading>
    )
  }

  return (
    <Link href="/planning/goal/task">
      <StyledHeading level="5" removeMargins={true} variant="mixed-weight">
        {t`Active Goal: `}
        <span>{name}</span>
      </StyledHeading>
    </Link>
  )
}

export { PlanName }
